import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const PillFormsGrpcContractProvider: Provider = {
  provide: MainApi.PillFormsGrpcContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.PillFormsGrpcContractClient, 'mainApi'),
};
